import React, { ChangeEvent, FocusEvent, MouseEvent } from 'react'
import { IIshikawaCategory } from '../types'

/**
   * Containner do texto de categoria,
   * @TODO Foi iniciado o evento para transformar em input para editar ou incluir mas ainda inacabado
   * @param index 
   * @param category 
   */
interface IGetCategory {
  index: number, category: IIshikawaCategory
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleBlur: (e: FocusEvent<HTMLInputElement>, category: IIshikawaCategory) => void
  handleDoubleClick: (e: MouseEvent<HTMLSpanElement>, category: IIshikawaCategory) => void
}
export default function GetCategory({
  index, category,
  handleChange,
  handleBlur,
  handleDoubleClick
}: IGetCategory) {
  return (
    <span>
      {category.editing ? (
        <input
          type="text" value={category.title}
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
          onBlur={(e: FocusEvent<HTMLInputElement>) => handleBlur(e, category)}
          autoFocus />
      ) : (
          <span
          data-testid="test-not-edit-span"
            key={`root_causes_${category.title}_${index}`}
          onDoubleClick={(e: MouseEvent<HTMLSpanElement>) => handleDoubleClick(e, category)}>
          {category.title}
        </span>)
      }
    </span>
  )
}
